import Seo from "@/components/feature/Seo";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import { faqList } from "@/mocks/faqs";
import { hotTopics } from "@/mocks/topics";
import { site } from "@/mocks/site";
import Categories from "./components/Categories";
import DeepSection from "./components/DeepSection";
import FaqSection from "./components/FaqSection";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import SubscribeSection from "./components/SubscribeSection";
import Ticker from "./components/Ticker";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: site.name,
    description: site.intro,
    email: site.email,
    url: "/",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: site.name,
    description: site.slogan,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "/ranking?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "实时热搜话题榜",
    itemListElement: hotTopics.slice(0, 10).map((topic, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: topic.title,
      url: `/topic/${topic.id}`,
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="爆点观察局_黑料网爆热搜_全网话题出圈扩散观察站"
        description="爆点观察局聚合全网正在发酵的黑料网爆话题，实时追踪热搜排名、转发量与出圈扩散轨迹，记录哪些瓜被传疯、哪些话题登上热搜，让你吃瓜不落伍。"
        keywords="黑料网爆,黑料网爆出圈,黑料网爆热搜,话题转发量,热点扩散观察,热搜榜"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main>
        <Hero />
        <Ticker />
        <HotBoard />
        <Categories />
        <DeepSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <ScrollToTop />
    </>
  );
}